// extracted by mini-css-extract-plugin
export default {"WorkWithProTeam":"style_WorkWithProTeam__N5l3V","container":"style_container__9d-ZW"};